<header id="header-container">
  <div class="header-container">
    @if (hasBackButton()) {
      <div class="wrap-back">
        <button class="back-btn" (click)="goBack()">
          <img
            class="header-arrow"
            src="../../../assets/img/new_arrow.svg"
            alt="back"
          />
          @if(this.no_logo){
            <span >{{"header.previous_step" | translate }}</span>
          }
        </button>
      </div>
    }

    @if (!this.no_logo) {
      <div
        class="wrap-img"
        [ngClass]="{ 'margin-logo': !hasBackButton() }"
      >
        <img
          alt="Costa Crociere"
          class="header-img"
          src="../../../assets/img/Costa.png"
          (click)="goTo('home')"
        />
      </div>
    }

    @if (!this.no_logo) {
      <div class="wrap-login">
        <div class="lang">
          <button
            class="button-flag"
            mat-icon-button
            color="primary"
            aria-label="Language icon"
            [matMenuTriggerFor]="menu"
          >
            <img
              src="../../../assets/img/lang/{{ userService.lang! }}.png"
              alt="{{ userService.lang! }}"
            />
          </button>
          <mat-menu class="menu-flag" #menu="matMenu">
            @for (lang of langs; track $index) {
              <div>
                <button
                  class="button-flag"
                  mat-menu-item
                  (click)="changeLang(lang)"
                >
                  <img
                    [src]="'../../../assets/img/lang/' + lang + '.png'"
                    [alt]="lang"
                  />
                  {{ "header." + lang | translate }}
                </button>
              </div>
            }
          </mat-menu>
        </div>
        @if (userService.displayName && !no_logo) {
          <div class="login" >
            <div class="bg" [matMenuTriggerFor]="menu2">
              <div class="name">{{ name }}</div>
              <div class="bg2"></div>
            </div>

            <mat-menu class="menu-user" #menu2="matMenu">
              <ul>
                @if (!userService.displayNameImp) {
                  <li (click)="logout()">
                    {{ "header.logout" | translate }}
                  </li>
                } @else {
                  <li  (click)="termina()">
                    {{ "header.logout" | translate }}
                  </li>
                }
              </ul>
            </mat-menu>
          </div>
        }

      </div>
    }

  </div>
</header>
